import { StateProvider } from 'apprise-frontend-core/state/provider'
import { EventSubscriber } from 'apprise-frontend-events/subscriptions'
import { PropsWithChildren } from 'react'
import { vesselType } from './constants'
import { VesselCache, VesselCacheContext } from './context'
import { useVesselChangeListener } from './events'



export type VesselProps = PropsWithChildren<Partial<{

    mock: boolean

}>>


export const Vessels = (props: VesselProps) => {

    const { children } = props


    return <VesselProvider>
        <VesselInitialiser >
            {children}
        </VesselInitialiser>
    </VesselProvider>



}


export type VesselProviderProps = PropsWithChildren


export const initialVesselCache: VesselCache = {}


const VesselProvider = (props: VesselProviderProps) => {

    const { children } = props

    return <StateProvider initialState={initialVesselCache} context={VesselCacheContext}>
        {children}
    </StateProvider>
}

export const VesselInitialiser = (props: VesselProps) => {

    const { children } = props

    const changeListener = useVesselChangeListener()

    return <EventSubscriber name={vesselType} subscriptions={[changeListener]}>
        {children}
    </EventSubscriber>

}